"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_DamageAbsorbEventHandlerScript = void 0;
const Duration_1 = require("../../core/Duration");
const MaxAttributeIncrease_1 = require("../../core/effects/core/MaxAttributeIncrease");
const AttributeType_1 = require("../../core/enums/AttributeType");
const EventType_1 = require("../../core/events/EventType");
const Registries_1 = require("../../core/state/Registries");
let Effect_DamageAbsorbEventHandlerScript = class Effect_DamageAbsorbEventHandlerScript {
    run(sequence, container, handler, event) {
        if (event.args.__type !== EventType_1.EventType.Damaged || !handler.args.scriptArgs.absorbFor.includes(event.subject) || !handler.args.scriptArgs.damageTypes.includes(event.args.damage.type)) {
            return;
        }
        if (!handler.meta.remainingDamage) {
            handler.meta.remainingDamage = handler.args.scriptArgs.damageAmount;
        }
        handler.meta.remainingDamage = handler.meta.remainingDamage - event.args.damage.amount;
        let healthIncrease = event.args.damage.amount;
        if (handler.meta.remainingDamage < 0) {
            healthIncrease = event.args.damage.amount + handler.meta.remainingDamage;
        }
        container.applyBuff({
            sequence,
            creatorId: event.subject,
            targetId: event.subject,
            effect: new MaxAttributeIncrease_1.MaxAttributeIncreaseEffectArgs(AttributeType_1.AttributeType.Health, healthIncrease),
            duration: Duration_1.Duration.Instant,
            onApplied: () => {
                if (handler.meta.remainingDamage <= 0) {
                    container.cancelEventHandler(handler.id);
                }
            }
        });
    }
};
Effect_DamageAbsorbEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_DamageAbsorb")
], Effect_DamageAbsorbEventHandlerScript);
exports.Effect_DamageAbsorbEventHandlerScript = Effect_DamageAbsorbEventHandlerScript;
